import React, { useEffect, useState } from 'react';
import { AlertCircle, CheckCircle2, Info } from 'lucide-react';
import { onToast } from '../utils/toast';

// Destructive or failed: red is allowed here. Everything else is quiet.
const ICONS = {
  error: <AlertCircle className="w-4 h-4 text-flag-red flex-shrink-0" />,
  success: <CheckCircle2 className="w-4 h-4 text-accent flex-shrink-0" />,
  info: <Info className="w-4 h-4 text-ink-2 flex-shrink-0" />,
};

export default function Toasts() {
  const [toasts, setToasts] = useState([]);

  useEffect(() => onToast((t) => {
    setToasts((prev) => [...prev.slice(-3), t]);
    // A toast with an action (undo) stays a little longer.
    setTimeout(() => setToasts((prev) => prev.filter((x) => x.id !== t.id)), t.action ? 7000 : 4500);
  }), []);

  const dismiss = (id) => setToasts((prev) => prev.filter((x) => x.id !== id));

  if (!toasts.length) return null;
  return (
    <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-[60] space-y-2 w-[calc(100%-2rem)] max-w-sm" aria-live="polite">
      {toasts.map((t) => (
        // `toast-enter` is a marker only (the capture tooling waits on it); there
        // is no entry animation any more.
        <div key={t.id} data-toast className="toast-enter bg-surface border border-line shadow-pop rounded-card px-4 py-3 flex items-center gap-2.5 text-body text-ink">
          {ICONS[t.type] || ICONS.info}
          <span className="flex-1">{t.message}</span>
          {t.action && (
            <button
              onClick={() => { t.action.onClick(); dismiss(t.id); }}
              className="text-body font-medium text-accent hover:underline flex-shrink-0"
            >
              {t.action.label}
            </button>
          )}
        </div>
      ))}
    </div>
  );
}
